import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderRailyTaxiDraftResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderRailyTaxiDraftResponseDataContractTaxiCompany = {
  companyName: string;
};

export type BillingsOrderRailyTaxiDraftResponseDataContract = {
  model: BillingsOrderRailyTaxiDraftResponseDataContractBillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiCorporation: BillingsOrderRailyTaxiDraftResponseDataContractTaxiCompany;
};

export type BillingsOrderRailyTaxiDraftResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventId?: string;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderRailyTaxiDraftResponseDataCargoOrder = {
  humanId: number;
};

export enum BillingsOrderRailyTaxiDraftResponseDataPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiDraftResponseDataBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

export type BillingsOrderRailyTaxiDraftResponseData = {
  contract: BillingsOrderRailyTaxiDraftResponseDataContract;
  billingNodes: BillingsOrderRailyTaxiDraftResponseDataBillingNode[];
  totalAmount: number;
  haltingAmount: number;
  highwayCharge: number;
  distance: number;
  distanceAmount: number;
  cargoOrder: BillingsOrderRailyTaxiDraftResponseDataCargoOrder;
  planEntryId: string;
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiDraftResponseDataPenaltyType;
  bonusType?: BillingsOrderRailyTaxiDraftResponseDataBonusType;
  date: Date;
};

type BillingsOrderRailyTaxiDraftResponse =
  HttpResponse<BillingsOrderRailyTaxiDraftResponseData>;

export default BillingsOrderRailyTaxiDraftResponse;
